// 導覽列 - 語言切換、收藏、通知、頭像、登入註冊按鈕
import { usePathname, useParams } from 'next/navigation';
import { IS_LIST_PATH } from '@/common/constant';
import HeaderToggleTheme from './HeaderToggleTheme'; // 切換深淺
import HeaderToggleLanguage from './HeaderToggleLanguage'; // 語言切換
import HeaderUserBlock from './HeaderUserBlock'; // 通知、頭像、登入註冊按鈕

const UserFunction = ({ user }) => {
    const pathname = usePathname();
    const params = useParams();
    const { newsSlug } = params;

    // 特定路徑判斷
    const isListPath = IS_LIST_PATH.includes(pathname) && !newsSlug;

    return (
        <div
            className={`flex items-center gap-x-[10px] [&>*]:trans [&>*]:rounded-[50%] [&>*]:w-[32px] [&>*]:h-[32px]
            [&>*]:center-center [&>*]:border-1 [&>*]:border-opacity-[.32] [&>*_img]:trans
            ${user?.uid ? '' : 'usm:!gap-x-0'}
            ${
                isListPath
                    ? `[&>*]:border-[#fff] [&_span]:filter-white [&>*:hover]:border-[#fff] [&>*:hover]:bg-[rgba(255,255,255,0.2)] 
                    ulg:[&_span]:filter-none ulg:[&>*:hover]:border-bou ulg:[&>*:hover]:bg-bou`
                    : '[&>*]:border-[#aa82c3]'
            }
            ulg:[&>*]:!border-[#aa82c3] ulg:[&>*]:!border-opacity-[.32]`}
        >
            {/* 切換深淺 */}
            <HeaderToggleTheme />

            {/* 語言切換 */}
            <HeaderToggleLanguage />

            {/* 通知、頭像、登入註冊按鈕 */}
            <HeaderUserBlock />
        </div>
    );
};

export default UserFunction;
